"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var icon_1 = __importDefault(require("../../icon"));
var MAX_COUNT = 5; // 可显示的最多list条目数
var SHOW_CCOUNT = 3; // 默认显示的数量
function ContentLayout(props) {
    var layout = props.layout, checkList = props.checkList, list = props.list, isHover = props.isHover;
    var showList = checkList === null || checkList === void 0 ? void 0 : checkList.slice(0, MAX_COUNT);
    var horList = list === null || list === void 0 ? void 0 : list.slice(0, MAX_COUNT);
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    function renderLayoutItems(laylist) {
        return (react_1.default.createElement(react_1.default.Fragment, null, laylist === null || laylist === void 0 ? void 0 : laylist.map(function (data, i) {
            var name = data.name, value = data.value;
            return (react_1.default.createElement("div", { key: "".concat(name, "-").concat(i), className: "layout-item" },
                react_1.default.createElement("span", { className: "item-name" }, name),
                react_1.default.createElement("span", { className: "item-value" }, value)));
        })));
    }
    // horizontal 水平布局
    function renderLayoutHor() {
        var clist = horList === null || horList === void 0 ? void 0 : horList.slice(0, SHOW_CCOUNT);
        var clsName = horList && (horList === null || horList === void 0 ? void 0 : horList.length) > SHOW_CCOUNT ? 'list-after' : '';
        if (isHover) {
            clist = horList;
            clsName = '';
        }
        return react_1.default.createElement("div", { className: (0, classnames_1.default)('layout-hor', clsName) }, renderLayoutItems(clist));
    }
    // vertical 垂直布局
    function renderLayoutVer() {
        return react_1.default.createElement("div", { className: "layout-ver" }, renderLayoutItems(list));
    }
    function renderLayoutCheckList() {
        var clist = showList === null || showList === void 0 ? void 0 : showList.slice(0, SHOW_CCOUNT);
        var clsName = showList && (showList === null || showList === void 0 ? void 0 : showList.length) > SHOW_CCOUNT ? 'list-after' : '';
        if (isHover) {
            clist = showList;
            clsName = '';
        }
        return (react_1.default.createElement("div", { className: "layout-clist" },
            react_1.default.createElement("ul", { className: (0, classnames_1.default)('activity-list', clsName) }, clist === null || clist === void 0 ? void 0 : clist.map(function (l, i) { return (react_1.default.createElement("li", { key: "content-list-".concat(i) },
                react_1.default.createElement("div", { className: "clist-icon" },
                    react_1.default.createElement(icon_1.default, { name: "check", size: 20 })),
                react_1.default.createElement("span", { className: "activity-list-content" }, l))); }))));
    }
    function renderLayout() {
        switch (layout) {
            case 'hor':
                return renderLayoutHor();
            case 'ver':
                return renderLayoutVer();
            case 'list':
                return renderLayoutCheckList();
            default:
                return null;
        }
    }
    return react_1.default.createElement("div", { className: "".concat(classPrefix, "-card-layout") }, renderLayout());
}
exports.default = ContentLayout;
//# sourceMappingURL=ContentLayout.js.map